import resolveImage from "./resolveImage";

const resolveObjectWithImage = ({ uid, image, ...rest }, idx) => ({
  ...rest,
  uid: uid || idx,
  image: resolveImage(image),
});

export default resolveObjectWithImage;
